export { DefaultSlide } from './default-slide';
export { CollageSlide } from './collage-slide';
export { ActivitiesAndEventsSlide } from './activities-and-events-slide';
export { ImageCentricSlide } from './image-centric-slide';
export { IndividualSpotlightSlide } from './individual-spotlight-slide';
export { NameInLightsSlide } from './name-in-lights-slide';
export { GifCentricSlide } from './gif-centric-slide';
